<template>
  <div class="main">
    <Nav />

    <div v-if="module" class="moduleList container">
      <div class="columns">
        <div class="column">
          <div class="level">
            <div class="level-left">
              <h1 class="title">{{module.title}}</h1>
            </div>
            <div class="level-right">
              <router-link
                class="button is-primary"
                :to="{name: 'moduleList', params:{parameters:this.listProps}}"
                v-if="fromList"
              >
                <span class="icon">
                  <i class="fas fa-angle-double-left"></i>
                </span>
                <span>Back to List</span>
              </router-link>
              <router-link
                class="button is-primary"
                :to="{name: 'schedule'}"
                v-else-if="fromSchedule"
              >
                <span class="icon">
                  <i class="fas fa-angle-double-left"></i>
                </span>
                <span>Back to Schedule</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column is-three-quarters">
          <div class="columns">
            <div class="column">
              <div class="tags">
                <span class="tag is-large is-info" v-if="!module.isCustom">Grade {{module.grade}}</span>
                <span class="tag is-large is-success" v-if="!module.isCustom">{{module.subject}}</span>
                <span class="tag is-large is-warning">{{module.type}}</span>
                <span
                  class="tag is-large is-danger"
                  v-if="!module.isCustom"
                >Units: {{module.units||"N/A"}}</span>
              </div>
            </div>
          </div>

          <div class="columns" v-if="module.description">
            <div class="column">
              <div class="box">
                <div class="content">
                  <h2 class="title">Description</h2>
                  <p>{{module.description}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="columns" v-if="!module.isCustom">
            <div class="column" v-if="module.current_tek_1">
              <div class="box">
                <div class="content">
                  <h2 class="title">Current TEKS</h2>
                  <ul>
                    <li v-if="module.current_tek_1">{{module.current_tek_1}}</li>
                    <li v-if="module.current_tek_2">{{module.current_tek_2}}</li>
                    <li v-if="module.current_tek_3">{{module.current_tek_3}}</li>
                    <li v-if="module.current_tek_4">{{module.current_tek_4}}</li>
                    <li v-if="module.current_tek_5">{{module.current_tek_5}}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="column" v-if="module.new_teks_19_20_1">
              <div class="box">
                <div class="content">
                  <h2 class="title">New TEKS</h2>
                  <ul>
                    <li v-if="module.new_teks_19_20_1">{{module.new_teks_19_20_1}}</li>
                    <li v-if="module.new_teks_19_20_2">{{module.new_teks_19_20_2}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="columns" v-if="!module.isCustom">
            <div class="column" v-if="module.equipment_1">
              <div class="box">
                <div class="content">
                  <h2 class="title">Equipment</h2>
                  <ul>
                    <li v-if="module.equipment_1">{{module.equipment_1}}</li>
                    <li v-if="module.equipment_2">{{module.equipment_2}}</li>
                    <li v-if="module.equipment_3">{{module.equipment_3}}</li>
                    <li v-if="module.equipment_4">{{module.equipment_4}}</li>
                    <li v-if="module.equipment_5">{{module.equipment_5}}</li>
                    <li v-if="module.equipment_6">{{module.equipment_6}}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="column" v-if="module.space_required_1">
              <div class="box">
                <div class="content">
                  <h2 class="title">Space Required</h2>
                  <ul>
                    <li v-if="module.space_required_1">{{module.space_required_1}}</li>
                    <li v-if="module.space_required_2">{{module.space_required_2}}</li>
                    <li v-if="module.space_required_3">{{module.space_required_3}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="columns" v-if="!module.isCustom">
            <div class="column">
              <div class="box">
                <h2 class="title">Steps</h2>
                <div class="content">
                  <ol>
                    <li v-if="module.step_1">{{module.step_1}}</li>
                    <li v-if="module.step_2">{{module.step_2}}</li>
                    <li v-if="module.step_3">{{module.step_3}}</li>
                    <li v-if="module.step_4">{{module.step_4}}</li>
                    <li v-if="module.step_5">{{module.step_5}}</li>
                    <li v-if="module.step_6">{{module.step_6}}</li>
                    <li v-if="module.step_7">{{module.step_7}}</li>
                    <li v-if="module.step_8">{{module.step_8}}</li>
                    <li v-if="module.step_9">{{module.step_9}}</li>
                    <li v-if="module.step_10">{{module.step_10}}</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div class="columns" v-if="module.variations">
            <div class="column">
              <div class="box">
                <div class="content">
                  <h2 class="title">Variations</h2>
                  <p>{{module.variations}}</p>
                </div>
              </div>
            </div>

            <div class="column" v-if="module.home_connection">
              <div class="box">
                <div class="content">
                  <h2 class="title">Home Connection</h2>
                  <p>{{module.home_connection}}</p>
                </div>
              </div>
            </div>
          </div>
          <section class="section">
            <div class="columns">
              <div class="column">
                <h2 class="title">Comments</h2>
                <CommentForm v-bind:moduleId="module.id" v-on:newComment="updateComments()" />
                <hr />
                <CommentList v-bind:moduleId="module.id" v-bind:serial="serial" />
              </div>
            </div>
          </section>
        </div>

        <div class="column">
          <div class="upcoming" v-if="dates && dates.length>0">
            <h2 class="title">Upcoming</h2>
            <div class="tags">
              <span
                class="tag is-gray is-small"
                v-for="date in dates"
                v-bind:key="date.id"
                v-on:click="remove(date.id)"
              >
                {{formatDate(date.date)}}
                <button class="delete is-small"></button>
              </span>
            </div>
            <hr />
          </div>
          <h2 class="title">Schedule this module</h2>
          <div class="content">
            <v-date-picker format="MM/DD/YYYY" is-inline is-expanded v-model="date" />
            <p>
              <vue-timepicker class="timepicker" format="h:mm A" v-model="time"></vue-timepicker>
            </p>
            <p v-if="date">{{formattedDate}}</p>
            <a
              class="button is-primary is-fullwidth"
              :disabled="!date"
              v-on:click="submitTime"
            >Add to Schedule</a>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import CommentForm from "../components/CommentForm";
import CommentList from "../components/CommentList";
import moment from "moment";
export default {
  name: "Module",
  data() {
    return {
      module: null,
      date: null,
      time: {
        h: "9",
        mm: "00",
        A: "AM"
      },
      dates: null,
      schedule: null,
      serial: 0
    };
  },
  props: ["listProps", "fromList", "fromSchedule"],
  mounted() {
    this.fetchData();
  },
  computed: {
    datestamp: function() {
      const adjustedHour = this.time.h === "12" ? 0 : parseInt(this.time.h);
      const hour = this.time.A === "AM" ? adjustedHour : adjustedHour + 12;
      const minutes = this.time.mm;
      return moment(this.date)
        .add(hour, "hour")
        .add(minutes, "minute");
    },
    formattedDate: function() {
      return this.datestamp.format("MM/DD/YYYY hh:mm A");
    }
  },

  methods: {
    fetchData: function() {
      const config = this.$store.getters.config;
      const url = `${process.env.VUE_APP_API_URL}module/${this.$route.params.id}`;
      axios.get(url, config).then(response => {
        this.module = response.data.module;
      });

      this.fetchSchedule();
      this.logAction("view_module", { module: this.$route.params.id });
    },

    fetchSchedule: function() {
      const config = this.$store.getters.config;
      const scheduleUrl = `${process.env.VUE_APP_API_URL}schedule/${this.$route.params.id}`;
      axios.get(scheduleUrl, config).then(response => {
        this.dates = response.data.schedule;
      });
    },

    submitTime: async function() {
      const date = this.datestamp.format("YYYY-MM-DD HH:mm:ss");
      const body = {
        moduleId: this.module.id,
        date
      };
      const config = this.$store.getters.config;
      await axios.post(`${process.env.VUE_APP_API_URL}schedule`, body, config);
      this.fetchSchedule();
      this.logAction("schedule_module", body);
    },

    logAction: async function(action, note) {
      const body = {
        action,
        note: JSON.stringify(note)
      };
      const config = this.$store.getters.config;
      await axios.post(`${process.env.VUE_APP_API_URL}log`, body, config);
    },

    formatDate: function(date) {
      return moment(date).format("MM/DD/YYYY h:mm");
    },
    updateComments: function() {
      this.serial = this.serial + 1;
    },

    remove: async function(id) {
      const config = this.$store.getters.config;
      await axios.delete(
        `${process.env.VUE_APP_API_URL}schedule/${id}`,
        config
      );
      this.fetchSchedule();
    }
  },

  components: {
    Nav,
    CommentForm,
    CommentList,
    Footer,
    VueTimepicker
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  padding-bottom: 2rem;
}
h1.title {
  font-size: 3rem;
}

.box {
  height: 100%;
}

.timepicker {
  margin-top: 10px;
}
</style>
